import { Controller } from "@hotwired/stimulus"

/**
 * Entspricht den Tabs aus tailwindcss-stimulus-components, aber:
 * - URL-Hash per history.replaceState setzen (nicht location.hash) → kein automatisches
 *   Nachscrollen im overflow-auto-Hauptbereich (CRM-Layout).
 * - Hash beim Laden über href der Tab-Links auflösen; Anker-IDs liegen auf den Panels.
 */
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.activeTabClasses = (this.element.getAttribute("data-tabs-active-tab") || "active")
      .split(" ")
      .filter(Boolean)
    this.inactiveTabClasses = (this.element.getAttribute("data-tabs-inactive-tab") || "inactive")
      .split(" ")
      .filter(Boolean)

    this._index = this.initialIndexFromHash()
    this.showTab()
  }

  initialIndexFromHash() {
    const raw = (document.URL.split("#")[1] || "").trim()
    if (!raw) return 0
    const hash = decodeURIComponent(raw)
    const idx = this.tabTargets.findIndex((tab) => {
      const href = tab.getAttribute("href")
      return href === `#${hash}` || (href && href.endsWith(`#${hash}`))
    })
    return idx >= 0 ? idx : 0
  }

  change(event) {
    event.preventDefault()
    const el = event.currentTarget
    if (el.dataset.index !== undefined && el.dataset.index !== "") {
      this._index = parseInt(el.dataset.index, 10)
    } else {
      this._index = this.tabTargets.indexOf(el)
    }
    this.showTab()
    window.dispatchEvent(new CustomEvent("tsc:tab-change"))
  }

  showTab() {
    const index = this._index >= 0 ? this._index : 0

    this.tabTargets.forEach((tab, i) => {
      const panel = this.panelTargets[i]
      if (!panel) return

      if (i === index) {
        panel.classList.remove("hidden")
        this.inactiveTabClasses.forEach((c) => tab.classList.remove(c))
        this.activeTabClasses.forEach((c) => tab.classList.add(c))

        const pid = panel.id
        if (pid) {
          const next = `${window.location.pathname}${window.location.search}#${pid}`
          history.replaceState(null, "", next)
        }
      } else {
        panel.classList.add("hidden")
        this.activeTabClasses.forEach((c) => tab.classList.remove(c))
        this.inactiveTabClasses.forEach((c) => tab.classList.add(c))
      }
    })
  }
}
